export const calculateItemAmount = (saleRate, qty, discount, gstPct) => {
  const baseAmount = (saleRate || 0) * (qty || 0);
  const afterDiscount = baseAmount * (1 - (discount || 0) / 100);
  const withGst = afterDiscount * (1 + (gstPct || 0) / 100);
  return withGst;
};

export const computeTotals = (items = []) => {
  const gross = items.reduce((s, x) => s + (x.amount || 0), 0);
  const taxableAmount = items.reduce((s, item) => {
    const base = (item.saleRate || 0) * (item.qty || 0);
    return s + base * (1 - (item.discount || 0) / 100);
  }, 0);
  const gstAmount = gross - taxableAmount;
  const roundOff = Math.round(gross) - gross;
  const totalAmount = Math.round(gross);
  const payable = totalAmount;

  return {
    totalProducts: items.length,
    taxableAmount,
    gstAmount,
    roundOff,
    totalAmount,
    payable,
  };
};
